<div class="container mt-3">
    <div class="main">
        <h1>{{nameOfTheSection}}</h1>
        <hr>
        <div class="row row-cols-1 row-cols-md-4  row-cols-sm-2 g-4 ">
            <app-product-card class="card p-0" *ngFor="let product of products" [product]="product">
            </app-product-card>
        </div>
    </div>
</div>